export default "__VITE_ASSET__CzZO5YUS__"